export default __webpack_public_path__ + "static/media/12.9dae7abe.jpg";